var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInboxinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 1H4a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h2.077a5 5 0 0 1 3.905 1.877L12 22.398l2.018-2.523A5 5 0 0 1 17.922 18H20a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3Zm-5.201 19.501A4 4 0 0 1 17.922 19H20a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v11a4 4 0 0 0 4 4h2.077a4 4 0 0 1 3.124 1.501L12 24l2.799-3.499Z",
  fill: "#252829"
})));
export default SvgInboxinline;